import { FC } from "react";
import NotificationProgressBar from "./NotificationProgressBar";

interface IPinkNotification {
    notificationRenderingSide: "top" | "right" | "bottom" | "left";
    text: string;
    icon?: string;
    iconText?: string;
    notificationWidthVW: number;
    moveFromTop?: number;
    hasCloseButton?: boolean;
    closeTheNotification?(): void;
    progressNumber?: number;
    isStatic?: boolean;
    isTextShort?: boolean;
    areDotsPositionedToBottom?: boolean;
}

const PinkNotification: FC<IPinkNotification> = (props) => {
    const { notificationRenderingSide, icon, iconText, notificationWidthVW, text, moveFromTop, hasCloseButton, closeTheNotification, isStatic } = props;

    if (!text)
        return <div></div>

    const getNotificationPositionAndSide = () => {
        switch (notificationRenderingSide) {
            case "top": return {bottom: `calc(100% + 10px)`, width: `${notificationWidthVW}vw`};
            case "right": return {right: `-${notificationWidthVW + 2 }vw`, width: `${notificationWidthVW}vw` }; 
            case "bottom": return {top: `calc(100% + 10px)`, width: `${notificationWidthVW}vw` };
            case "left": return {left: `-${notificationWidthVW + 3 }vw`, width: `${notificationWidthVW}vw` };     
        }
    }

    const getSwingingAnimation = () => {
        if (isStatic) return staticAnimationCss();
        return swingingAnimationCss();
    }

    const swingingAnimationCss = () => {
        switch (notificationRenderingSide) {
            case "top": return "move_on_top center_horizontally";
            case "right": return "move_on_right center_vertically";
            case "bottom": return "move_on_bottom center_horizontally";
            case "left": return "move_on_left center_vertically";
        }
    }

    const staticAnimationCss = () => {
        switch (notificationRenderingSide) {
            case "top": return "center_horizontally";
            case "right": return "center_vertically";
            case "bottom": return "center_horizontally";
            case "left": return "center_vertically";
        }
    }

    const getAlignmentDirection = () => {
        switch (notificationRenderingSide) {
            case "top": return "center_horizontally";
            case "right": return "center_vertically_start_horizontally";
            case "bottom": return "center_horizontally";
            case "left": return "center_vertically_end_horizontally";
        }
    }

    const getNotchPositionAndSide = () => {
        switch (notificationRenderingSide) {
            case "top": return {bottom: "-0.3vw"};
            case "right": return {left: "-0.3vw"}; 
            case "bottom": return {top: "-0.3vw"};
            case "left": return {right: "-0.3vw"};     
        }
    }

    const getTopPositioning = () => {
        if (moveFromTop)
            return {top: `${moveFromTop}px`}

        return {}
    }

    return(
   
            <div className="pink_notification_wrapper" style={getTopPositioning()}>
                <div className={`pink_notification ${getAlignmentDirection()} `} style={getNotificationPositionAndSide()}>

                    <div className={`pink_notification_swinging_animation_wrapper ${getAlignmentDirection()} ${getSwingingAnimation()}`}>
                        {!isStatic && <div className="pink_notification_notch" style={getNotchPositionAndSide()}></div>}
                        <div className="pink_notification_body"> 
                            <div className="pink_notification_text"> {text} </div>
                            {icon && 
                            <div className="pink_notification_picture_wrapper ">
                                <img src={icon} className="pink_notification_picture" alt="icon" />
                                <div className="notification_icon_text center_vertically">{iconText}</div>
                            </div>
                            }
                        </div>
                        {hasCloseButton && <div className="pink_notification_close_button" onClick={closeTheNotification}></div> }
                    </div>
                    
                </div>
            </div>
    )
   
  };

export default PinkNotification;
